import styled from '@emotion/styled'
import { Flex } from '@chakra-ui/react'

const PaginationSt = styled(Flex)`
  gap: 5px;
`

export { PaginationSt }
